module.exports = __webpack_public_path__ + "img/lisongyang.aaed5aee.jpg";